export interface VoiceChatReveal {
  question: string;
  lines: string[];
  shown: number;
  activeIndex?: number;
  overall?: number;
}

/** A transcrição e a pergunta salva diferem só por espaços e quebras. */
export function sameSpokenQuestion(a: string, b: string): boolean {
  const norm = (value: string) => value.replace(/\s+/g, ' ').trim();
  return norm(a) === norm(b);
}
